import { apiService } from './api'
import type { CreateEducationData, UpdateEducationData } from '@/types'

class EducationService {
  async getEducation(params?: any) {
    const response = await apiService.api.get('/admin/education', { params })
    return response.data
  }

  async getAllEducation() {
    const response = await apiService.api.get('/admin/education/all')
    return response.data
  }

  async getEducationItem(id: string | number) {
    const response = await apiService.api.get(`/admin/education/${id}`)
    return response.data
  }

  async createEducation(data: CreateEducationData) {
    const response = await apiService.api.post('/admin/education', data)
    return response.data
  }

  async updateEducation(id: string | number, data: UpdateEducationData) {
    const response = await apiService.api.put(`/admin/education/${id}`, data)
    return response.data
  }

  async deleteEducation(id: string | number) {
    await apiService.api.delete(`/admin/education/${id}`)
  }

  async getEducationStats() {
    const response = await apiService.api.get('/admin/education/stats')
    return response.data
  }
}

export const educationService = new EducationService()